// extracted by mini-css-extract-plugin
export var label = "_gz-2";
export var slideContainer = "_gz-0";
export var slider = "_gz-1";